<template>
    <transition name="layout-fade">
        <v-layout wrap column class="layout-add layout-add--max_width">
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Добавить отзыв</v-toolbar-title>
                <v-spacer/>
                <v-btn color="info" class="v-btn--save" :loading="loading" :disabled="loading" @click="sendForm">
                    Сохранить
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
            </v-toolbar>
            <v-form class="form-add">
                <v-flex xs12>
                    <v-subheader class="pa-0">Название</v-subheader>
                    <v-text-field
                        ref="review_name"
                        v-model="review.name"
                        v-validate="'required'"
                        data-vv-name="name"
                        :error-messages="errors.collect('name')"
                        text
                        solo
                        single-line
                        required/>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Источник</v-subheader>
                            <v-text-field
                                ref="review_from"
                                v-model="review.from"
                                v-validate="'required'"
                                data-vv-name="from"
                                :error-messages="errors.collect('from')"
                                text
                                solo
                                single-line
                                required/>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Статус</v-subheader>
                            <v-checkbox :label="review.status ? 'Включен' : 'Отключен'" v-model="review.status"
                                        class="mt-0"/>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-subheader class="pa-0">Текст</v-subheader>
                    <v-textarea
                        ref="review_body"
                        v-model="review.body"
                        v-validate="'required|max:191'"
                        data-vv-name="body"
                        :error-messages="errors.collect('body')"
                        text
                        solo
                        single-line
                        required
                        counter="191"/>
                </v-flex>
            </v-form>
        </v-layout>
    </transition>
</template>

<script>
    import Review from '../../../api/review'

    export default {
        name: 'addReview',
        $_veeValidate: {
            validator: 'new'
        },
        data: () => ({
            loading: false,
            review: {
                name: '',
                from: '',
                body: '',
                status: true
            },
            dictionary: {
                custom: {
                    name: {
                        required: 'Имя не введено'
                    },
                    from: {
                        required: 'Источник отзыва не указан'
                    },
                    body: {
                        required: 'Текст не введен',
                        max: 'Превышано максимальное количество символов'
                    }
                }
            }
        }),
        mounted () {
            this.$validator.localize('ru', this.dictionary)
        },
        methods: {
            sendForm () {
                this.$validator
                    .validateAll()
                    .then(isValid => {
                        if (!isValid) return

                        this.loading = true

                        Review
                            .create(this.review)
                            .then(response => {
                                this.$store.commit('storeReview', response.data.data)
                                this.$store.commit('showSnackbar', {
                                    text: 'Успех! Отзыв создан',
                                    color: 'success'
                                })
                                this.$router.push({ name: 'reviewRoot' })
                            })
                            .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
                            .finally(() => this.loading = false)
                    })
                    .catch(error => new Error(error))
            }
        }
    }
</script>
